import "./action/radio.js";
import "./action/sticky.js";
import "./comment/comment.js";
import "./form/form.js";
import "./header/header.js";
import "./langswitch/langswitch.js";
import "./modal/modal.js";
import "./scrolltop/scrolltop.js";
import "./tab/tab.js";
